import { render, staticRenderFns } from "./user-picker-multiple.vue?vue&type=template&id=6239e702&scoped=true&"
import script from "./user-picker-multiple.vue?vue&type=script&lang=js&"
export * from "./user-picker-multiple.vue?vue&type=script&lang=js&"
import style0 from "./user-picker-multiple.vue?vue&type=style&index=0&id=6239e702&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6239e702",
  null
  
)

export default component.exports